module.exports = __webpack_public_path__ + "img/erivania.2fb5342b.jpeg";